import { VolleyballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const TechnicalErrorsPopup = new PopupBuilder('Technical Errors', {
  incident_id: VolleyballIncidentId.TechnicalErrors,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
